import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { Style } from '../../style';
import {
  setCurrentServeType,
  setCustomizedServeType,
} from '../../../actions/mode/modeAction';

function ServeTypeRow() {
  type orderServeType =
    | 'DEFAULT'
    | 'DINE_IN'
    | 'TAKE_OUT'
    | 'SCHEDULE_TAKE_OUT'
    | 'DELIVERY'
    | 'PICK_UP'
    | 'PAY'
    | 'EMPLOYEE'
    | 'GUEST';
  const [selectedServeType, setSelectedServeType] =
    useState<orderServeType>('DEFAULT');
  const webStoreVoResponse = useSelector(
    (state: RootStateOrAny) => state.welcomeReducer.webStoreVoResponse
  );
  const projectName = useSelector<RootStateOrAny, any>(
    (state) => state.modeReducer.projectName
  );

  const style = new Style();
  const dispatch = useDispatch();
  useEffect(() => {
    switch (projectName) {
      case 'PHISON':
        setSelectedServeType('EMPLOYEE');
        dispatch(setCurrentServeType('TAKE_OUT'));
        dispatch(setCustomizedServeType('EMPLOYEE'));
        return;
      case 'HTY':
        dispatch(setCurrentServeType('TAKE_OUT'));
        return;
      default:
        setSelectedServeType(
          webStoreVoResponse.data.webStoreVo.availableServeTypes[0]
        );
        dispatch(
          setCurrentServeType(
            webStoreVoResponse.data.webStoreVo.availableServeTypes[0]
          )
        );
        return;
    }
  }, []);

  switch (projectName) {
    case 'PHISON':
      const orderServeTypes: orderServeType[] = ['EMPLOYEE', 'GUEST'];
      const content: string[] = ['employee', 'guest'];
      let borderRadius = ['10px 0px 0px 10px', '0px 10px 10px 0px'];
      return (
        <div
          className="d-flex justify-content-around"
          style={{ marginTop: '40px', overflow: 'hidden' }}
        >
          {orderServeTypes.map((serveType: orderServeType, i: number) => {
            let btnColor =
              selectedServeType === serveType
                ? style.primaryBtnSelected()
                : style.primaryBtn();
            const buttonStyle: object = {
              ...btnColor,
              width: '38.5vw',
              height: '44px',
              borderRadius: borderRadius[i],
            };
            return (
              <div key={i}>
                <input
                  type="radio"
                  className="btn-check"
                  id={'availableServeTypes-' + serveType}
                  name="availableServeTypes"
                  autoComplete="off"
                  checked={selectedServeType === serveType}
                  onChange={() => {
                    dispatch(setCurrentServeType('TAKE_OUT'));
                    dispatch(setCustomizedServeType(orderServeTypes[i]));
                    setSelectedServeType(serveType);
                  }}
                />
                <label
                  className="btn btn-lg btn-block serveType"
                  style={buttonStyle}
                  data-testid={'availableServeTypes-' + serveType + 'label'}
                  htmlFor={'availableServeTypes-' + serveType}
                >
                  <FormattedMessage id={'phison.' + content[i]} />
                </label>
              </div>
            );
          })}
        </div>
      );
    case 'HTY':
    case 'offline':
      // TODO : move the offline component to here(暫停服務)
      return null;
    default:
      return (
        <div
          className={
            webStoreVoResponse.data.webStoreVo.availableServeTypes.length < 3
              ? 'd-flex w-100 justify-content-around'
              : 'd-flex w-100 justify-content-between'
          }
          style={{ marginTop: '40px' }}
        >
          {webStoreVoResponse.data.webStoreVo.availableServeTypes.map(
            (serveType: orderServeType, i: number) => {
              return (
                <div key={i} className="d-flex" style={{ width: '33%' }}>
                  <input
                    type="radio"
                    className="btn-check"
                    id={'availableServeTypes-' + serveType}
                    name="availableServeTypes"
                    autoComplete="off"
                    checked={selectedServeType === serveType}
                    onChange={() => {
                      dispatch(setCurrentServeType(serveType));
                      setSelectedServeType(serveType);
                    }}
                  />
                  <label
                    className="btn btn-lg btn-block serveType"
                    style={
                      selectedServeType === serveType
                        ? style.primaryBtnSelected()
                        : style.primaryBtn()
                    }
                    data-testid={'availableServeTypes-' + serveType + 'label'}
                    htmlFor={'availableServeTypes-' + serveType}
                  >
                    <FormattedMessage
                      id={'welcome.availableServeTypes.' + serveType}
                    />
                  </label>
                </div>
              );
            }
          )}
        </div>
      );
  }
}

export default ServeTypeRow;
